import { render, staticRenderFns } from "./BrevoParametersDisplay.vue?vue&type=template&id=5312f8a0&scoped=true&"
import script from "./BrevoParametersDisplay.vue?vue&type=script&lang=js&"
export * from "./BrevoParametersDisplay.vue?vue&type=script&lang=js&"
import style0 from "./BrevoParametersDisplay.vue?vue&type=style&index=0&id=5312f8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5312f8a0",
  null
  
)

export default component.exports